// extracted by mini-css-extract-plugin
export default {"container":"Registration_container__vpT+c"};